<!--
Author: TangChen
Date: 2018-09-17
Desc: 菜单组件，由index.js 配置引入
-->
<template>
    <div class="comp-menu comp">
        <el-menu
            v-if="menus.length"
            :default-active="menuCheck"
            class="el-menu-out"
            mode="horizontal"
            :unique-opened="true"
            router
        >
            <div class="clear">
                <div v-for="(item,i) of menus" :key="i" class="left" :style="{'width':computedWidth}">
                    <el-submenu v-if="item.menu" :index="item.i">
                        <template slot="title">
                            <span>{{ item.name }}</span>
                        </template>
                        <template v-if="item.menu">
                            <el-menu-item
                                v-for="(items,j) in item.menu"
                                :key="j"
                                :index="items.link"
                            >
                                {{ items.name }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                    <el-menu-item v-else :index="item.link" class="grouped">
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </div>
            </div>
        </el-menu>
    </div>
</template>
<script>
export default {
    name: "NavMenu",
    props: {
        active: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            hadXJB: false,
            hadZHTZ: false, //是否购买组合投资模块，默认未购买
            hadZNDT: false,
            menus: [
                { icon: "fa fa-home", name: "我的资产", i: "1", link: "/org/home" },
                {
                    icon: "fa fa-shopping-cart",
                    name: "基金交易",
                    i: "2",
                    menu: [
                        { name: "基金超市", link: "/fund" },
                        { name: "基金转换", link: "/cfund" }
                    ]
                },
                // {
                //     icon: "fa fa-gem",
                //     name: "高端理财",
                //     i: "3",
                //     menu: [
                //         { name: "高端理财产品", link: "/privatefund" },
                //         { name: "我的高端理财", link: "/private" }
                //     ]
                // },
                {
                    icon: "fa fa-user",
                    name: "信息查询",
                    i: "4",
                    menu: [
                        { name: "交易查询", link: "/traderecord" },
                        // { name: "账户查询", link: "/acctApplication" },
                        { name: "分红查询", link: "/dividend" },
                        // { name: "信息披露", link: "/infoPublish" },
//                        { name: "汇款信息", link: "/remitinfo" },
                        { name: "对账单信息", link: "/statement" }
                    ]
                },
                {
                    icon: "fa fa-user",
                    name: "账户管理",
                    i: "5",
                    // link: "/orginfo",
                    menu: [
                        { name: "信息中心", link: "/orginfo" },
                        { name: "风险测评", link: "/orginfo/risk" },
                        { name: "投资者信息补录", link: "/orginfo/infocollection" },
                        /*{ name: "投资者转换", link: "/orginfo/invchange" },
                        { name: "税收信息", link: "/orginfo/taxeslist" }*/
                    ]
                }
            ],
            icon: {
                w: "24"
            },
            menuCheck: "/org/home"
        };
    },
    computed: {
        computedWidth(){
            return (60 / this.menus.length).toFixed(2) + "%";
        }
    },
    mounted() {
        // 获取当前选中菜单
        const _x = this.$route.path;
        const x = _x.split("/");
        this.hadZHTZ = this.$cache.getStatus("ZHTZ") == "1" ? true : false;
        this.hadZNDT = this.$cache.getStatus("ZNDT") == "1" ? true : false;
        this.hadXJB = this.$cache.getStatus("PTXJB") == "1" || this.$cache.getStatus("QCXJB") == "1" ? true : false;
        if(!this.hadZHTZ){
            let index = 0;
            for(let i in this.menus){
                if(this.menus[i].name == "基金交易"){
                    index = i;
                    break;
                }
            }
            this.menus[index].menu = [
                { name: "基金超市", link: "/fund" },
                { name: "基金转换", link: "/cfund" }
            ];
        }
        if(this.$cache.getStatus("GDLC") == "0") {
            for(let i in this.menus){
                if(this.menus[i].name == "高端理财"){
                    this.menus.splice(i,1);
                    break;
                }
            }
        }
        if(this.$cache.getStatus("SHZSG") == "0") {
            for(let i in this.menus){
                if(this.menus[i].name == "基金交易"){
                    for(let j in this.menus) {
                        if(this.menus[i].menu[j].name == "基金转换"){
                            this.menus[i].menu.splice(j,1);
                            break;

                        }
                    }
                }
            }
        }
        if(this.$cache.getUser().usertype === "2") {
            for(let i in this.menus){
                /*if(this.menus[i].name == "信息查询"){
                    for(let j in this.menus) {
                        if(this.menus[i].menu[j].name == "对账单信息"){
                            this.menus[i].menu.splice(j,1);
                            break;
                        }
                    }
                }*/
                if (this.menus[i].name == "账户管理") {
                    this.menus.splice(i, 1);
                    break;
                }
            }
        }
        this.menus.forEach(item=>{
            if(item.menu&&item.menu.length===1){
                item.name=item.menu[0].name
                item.link=item.menu[0].link
                delete item.menu
            }
        })
        // 菜单自动选中
        /* if (x.length > 2) {
            this.menuCheck = "/" + x[1];
        } else {
            this.menuCheck = _x;
        } */
        this.menuCheck = _x;
    },
    methods: {

    }
};
</script>
<style lang="scss">
    .comp-menu {
        .el-menu.el-menu-out {
            border: none;
            width: 1200px;
            margin: 0 auto;
            background: inherit;
            .el-menu-item.grouped,
            .el-submenu .el-submenu__title {
                text-align: center;
                font-size: 16px;
                line-height: 50px;
                padding: 0;
                height: 50px;
                i {
                    color: inherit;
                    display: inline-block;
                    text-align: center;
                    right: 10px;
                    margin-top: -5px;
                }
            }
        }
    }
</style>
